'use strict';

var GridContributingFBGsFilterFactory = function GridContributingFBGsFilterFactory(DemandFilter, angularHelper, featureToggleService) {
  var filtersNamesList = ['FBGsFilterByClassFactory'];
  if (featureToggleService.isEnabled('SPOS')) {
    filtersNamesList.push('FilterBySposFactory');
  }
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function GridContributingFBGsFilter() {
    DemandFilter.call(this, 'fares-mode', 'contributing-fbgs');
    this.registerFilters(injectedFilters);
  }
  GridContributingFBGsFilter.prototype = Object.create(DemandFilter.prototype);
  GridContributingFBGsFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return GridContributingFBGsFilter;
};
GridContributingFBGsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper', 'FeatureToggleService'];
module.exports = GridContributingFBGsFilterFactory;